/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Speed_Manual_TitleInputs */

const en_audio_recorder_speed_manual_title = /** @type {(inputs: Audio_Recorder_Speed_Manual_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual speed`)
};

const fr_audio_recorder_speed_manual_title = /** @type {(inputs: Audio_Recorder_Speed_Manual_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitesse manuelle`)
};

const de_audio_recorder_speed_manual_title = /** @type {(inputs: Audio_Recorder_Speed_Manual_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuelle Geschwindigkeit`)
};

const it_audio_recorder_speed_manual_title = /** @type {(inputs: Audio_Recorder_Speed_Manual_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocità manuale`)
};

const ru_audio_recorder_speed_manual_title = /** @type {(inputs: Audio_Recorder_Speed_Manual_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ручная скорость`)
};

const es_audio_recorder_speed_manual_title = /** @type {(inputs: Audio_Recorder_Speed_Manual_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad manual`)
};

const zh_cn2_audio_recorder_speed_manual_title = /** @type {(inputs: Audio_Recorder_Speed_Manual_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手动挡`)
};

const ja_audio_recorder_speed_manual_title = /** @type {(inputs: Audio_Recorder_Speed_Manual_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手動速度`)
};

const hi_audio_recorder_speed_manual_title = /** @type {(inputs: Audio_Recorder_Speed_Manual_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैनुअल गति`)
};

const pt_pt2_audio_recorder_speed_manual_title = /** @type {(inputs: Audio_Recorder_Speed_Manual_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidade manual`)
};

/**
* | output |
* | --- |
* | "Manual speed" |
*
* @param {Audio_Recorder_Speed_Manual_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_speed_manual_title = /** @type {((inputs?: Audio_Recorder_Speed_Manual_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Speed_Manual_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_speed_manual_title(inputs)
	if (locale === "de") return de_audio_recorder_speed_manual_title(inputs)
	if (locale === "it") return it_audio_recorder_speed_manual_title(inputs)
	if (locale === "ru") return ru_audio_recorder_speed_manual_title(inputs)
	if (locale === "es") return es_audio_recorder_speed_manual_title(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_speed_manual_title(inputs)
	if (locale === "ja") return ja_audio_recorder_speed_manual_title(inputs)
	if (locale === "hi") return hi_audio_recorder_speed_manual_title(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_speed_manual_title(inputs)
	return en_audio_recorder_speed_manual_title(inputs)
});